import React, { Fragment } from 'react'
import { Route, Switch } from 'react-router-dom'
import { Redirect } from 'react-router'
import Helmet from 'react-helmet'
import { getSectionLabel, url2section } from 'ion-sections'

import DefaultSectionPage from '../pages/DefaultSectionPage'
import HoverZoomSectionPage from '../pages/HoverZoomSectionPage'
import AuthorSectionPage from '../pages/AuthorSectionPage'
import AuthorArticles from '../templates/Articles/AuthorArticles'
import Article from '../pages/Article'
import NotFound from '../pages/NotFound'
import qs from 'qs'

const DefaultSection = (props) => {
  const params = props.location ? qs.parse(props.location.search, { ignoreQueryPrefix: true }) : { page: 0 }
  const isPage0 = (params.page || 0) < 2
  return (
    <>
      <Helmet titleTemplate={props.titleTemplate} />
      <Switch>
        <Route path={props.match.url + '/:section([a-zA-Z0-9-]+)/'} strict exact render={p => <Redirect to={props.match.url + '/' + p.match.params.section} />} />
        {props.match.url === props.location.pathname && (
          <Switch>
            <Route
              path='/design' exact render={(p) =>
                <DefaultSectionPage
                  {...props} {...p} isPage0={isPage0}
                  section='design'
                  title='Home, Garden &amp; Decor Design News | South Africa | House &amp; Garden'
                  description='Discover all the latest home, garden &amp; decor design trends. Check out the best-kept secrets that industry insiders will never tell you about. '
                />}
            />
            <Route
              path='/design/trends' exact render={(p) =>
                <DefaultSectionPage
                  {...props} {...p} isPage0={isPage0}
                  section='design/trends'
                  title='Interior and home design trends | House & Garden South Africa'
                  description='Top home and interior design trends according to House & Garden SA. All of the most popular design ideas in one chic digital environment. Be the first to hear about the latest design and decor ideas'
                />}
            />
            <Route
              path='/design/art' exact render={(p) =>
                <DefaultSectionPage
                  {...props} {...p} isPage0={isPage0}
                  section='design/art'
                  title='South African and International Art and Design | House & Garden South Africa'
                  description='Everything House & Garden knows about Art, including the most recent news, trends, greatest art shows, and profiles on the most recent artists to be aware of'
                />}
            />
            <Route
              path='/design/architecture' exact render={(p) =>
                <DefaultSectionPage
                  {...props} {...p} isPage0={isPage0}
                  section='design/architecture'
                  title='Innovative Architectural Design Trends | House & Garden South Africa'
                  description='Keep up with luxury architecture design houses and news, including profiles on remarkable talent. Take a look at some of the best designed homes and design trends'
                />}
            />
            <Route
              path='/design/innovative' exact render={(p) =>
                <DefaultSectionPage
                  {...props} {...p} isPage0={isPage0}
                  section='design/innovative'
                  sectionLabel='Innovative Designs'
                  title='Innovative Design trends | House & Garden South Africa'
                  description='Collection of eye-catching, smart, original, and trend-setting designs from the design world.'
                />}
            />
            <Route
              path='/doty-awards' exact render={(p) =>
                <DefaultSectionPage
                  {...props} {...p} isPage0={isPage0}
                  section='doty-awards'
                  sectionLabel='DOTY Awards'
                  title='DOTY Awards - House & Garden South Africa | Celebrating South African Design Excellence'
                  description="Discover House & Garden SA's DOTY Awards, celebrating South Africa's leading designers, architects, artists and creatives"
                  keywords='Designer of the Year, House & Garden, Award ceremony, Creative vision, Celebrating designers, Architecture, Urban design, Interiors, Space today, South African designers, Local designers'
                />}
            />
            <Route
              path='/interiors' exact render={(p) =>
                <DefaultSectionPage
                  {...props} {...p} isPage0={isPage0}
                  section='interiors'
                  sectionLabel='Interior Décor'
                  title='Interior Design for Your Home &amp; Living Spaces | House &amp; Garden'
                  description='From classic to contemporary, industrial to urban, House and Garden has all the tricks and tips to turn your living room into a space that suits your personality best.'
                />}
            />
            <Route
              path='/interiors/bathroom' exact render={(p) =>
                <DefaultSectionPage
                  {...props} {...p} isPage0={isPage0}
                  section='interiors/bathroom'
                  title='Discover beautiful bathroom inspirations | House & Garden South Africa'
                  description='Find stunning bathroom design inspirations & trends, cutting-edge concepts, and bold wallpaper ideas to style, embellish, and enhance your bathroom area.'
                />}
            />
            <Route
              path='/interiors/bedroom' exact render={(p) =>
                <DefaultSectionPage
                  {...props} {...p} isPage0={isPage0}
                  section='interiors/bedroom'
                  title='Top interior design tips for your bedroom | House & Garden South Africa'
                  description="Your most fashionable haven should be your bedroom. Here are suggestions, DIY tips and advice on everything you require to design the bedroom of your dreams. Find what's currently trending in the DIY space."
                />}
            />
            <Route
              path='/interiors/kitchen' exact render={(p) =>
                <DefaultSectionPage
                  {...props} {...p} isPage0={isPage0}
                  section='interiors/kitchen'
                  title='Discover the latest kitchen trends for 2023 | House & Garden South Africa'
                  description='With our helpful trend forecasts, you can design the kitchen of your dreams. Your kitchen is the gathering place for family and friends in your home.'
                />}
            />
            <Route
              path='/interiors/living-room' exact render={(p) =>
                <DefaultSectionPage
                  {...props} {...p} isPage0={isPage0}
                  section='interiors/living-room'
                  title='Ideas for kitchens from top interior designers worldwide | House & Garden South Africa'
                  description="In need of motivation. We've gathered ideas, advice, trends and recommendations from local and worldwide designers on how to breathe new life into your living room through design, decoration, and renovation."
                />}
            />
            <Route
              path='/interiors/house-tours' exact render={(p) =>
                <DefaultSectionPage
                  {...props} {...p} isPage0={isPage0}
                  section='interiors/house-tours'
                  title='House Tours: Explore Beautiful Homes & Interiors | House & Garden'
                  description='Take a look inside stunning homes worldwide getting inspired by décor, design ideas, and elegant interiors.'
                />}
            />
            <Route
              path='/gardens' exact render={(p) =>
                <DefaultSectionPage
                  {...props} {...p} isPage0={isPage0}
                  section='gardens'
                  title="South Africa's elite guide to the most stylish gardens | House & Garden South Africa"
                  description='How to create a beautiful landscape and tips on how to care for your plants, flowers, herbs, succulents and trees. Trends and hacks to seasonal changes to keep your garden thriving'
                />}
            />
            <Route
              path='/travel-leisure' exact render={(p) =>
                <DefaultSectionPage
                  {...props} {...p} isPage0={isPage0}
                  section='travel-leisure'
                  title='Leading worldwide and local travel guides | House & Garden South Africa'
                  description="Seeking some relaxation? If you're looking for tips on how to maximize your upcoming vacation or weekend getaway, start here"
                />}
            />
            <Route
              path='/travel-leisure/gourmet-restaurant-awards' exact render={(p) =>
                <DefaultSectionPage
                  {...props} {...p} isPage0={isPage0}
                  section='travel-leisure/gourmet-restaurant-awards'
                  title='Gourmet Restaurant Awards | South Africa |House &amp; Garden'
                  description='As one of South Africa’s favourite foodie mag, we’ve taste-tested the ultimate crave-worthy recipes fit for all seasons. Find out what to cook, drink, read and eat right now'
                />}
            />
            <Route
              path='/recipes' exact render={(p) =>
                <DefaultSectionPage
                  {...props} {...p} isPage0={isPage0}
                  section='food'
                  title="The Latest Food News: Trends, Launches & Culinary Insights | South Africa's Finest Decor Magazine"
                  description='Stay updated with SA breaking food news, tasty trends, product launches, and expert culinary updates.'
                />}
            />
            <Route
              path='/food/recipes' exact render={(p) =>
                <DefaultSectionPage
                  {...props} {...p} isPage0={isPage0}
                  section='food/recipes'
                  title='Delicious recipes for every occasion | House & Garden South Africa'
                  description="From laid-back brunches and TikTok trends to 5-star dinners and Instagram-worthy desserts, we have delicious food recipes for every occasion. Follow your favourite chef's latest cookbooks and how to re-create their tasty meals"
                />}
            />
            <Route
              path='/food/reviews' exact render={(p) =>
                <DefaultSectionPage
                  {...props} {...p} isPage0={isPage0}
                  section='food/reviews'
                  title=''
                  description=''
                />}
            />
            <Route
              path='/food/restaurants' exact render={(p) =>
                <DefaultSectionPage
                  {...props} {...p} isPage0={isPage0}
                  section='food/restaurants/'
                  title=''
                  description=''
                />}
            />
            <Route
              path='/diy' exact render={(p) =>
                <DefaultSectionPage
                  {...props} {...p} isPage0={isPage0}
                  section='diy'
                  title='DIY to Enhance Your Home | House & Garden South Africa'
                  description='Become a DIY expert with our wide range of content, from how to grow your own vegetable garden to decorate with paint and handy tricks to use around the house.'
                />}
            />
            <Route
              path='/video' exact render={(p) =>
                <DefaultSectionPage
                  {...props} {...p} isPage0={isPage0}
                  section='video'
                  title='Take a look at the most current interior videos | House & Garden South Africa'
                  description='Visit House and Garden SA to view all the most recent art and design inspired video content. From celebrity home tours, home renovations and event coverage, we provide you exclusive experiences and ideas for your own home.'
                />}
            />
            <Route
              path='/win' exact render={(p) =>
                <DefaultSectionPage
                  {...props} {...p} isPage0={isPage0}
                  section='win'
                  title='Enter to Win Competitions and Give Aways | House &amp; Garden'
                  description='Enter our competitions and stand a chance to win incredible prizes and travel experiences by entering our competitions. Don’t miss out on amazing giveaways.'
                />}
            />
            <Route
              path='/shopping' exact render={(p) =>
                <DefaultSectionPage
                  {...props} {...p} isPage0={isPage0}
                  section='shopping'
                  title='Stylish Home Decor Must-Haves: Shop the Latest Trends in Furniture | House &amp; Garden'
                  description='Elevate your home with our curated decor collection. Shop furniture, lighting, and accessories to transform your space. Find inspiration from House and Garden.'
                />}
            />
            <Route
              path='/shopping/gift-guide' exact render={(p) =>
                <HoverZoomSectionPage
                  {...props} {...p} isPage0={isPage0}
                  section='shopping/gift-guide'
                  title="House & Garden's Ultimate SA Gift Guide: Spoil the Homebody in Your Life"
                  description="Say yes to endless gifting options that'll make their home feel like a sanctuary, discover a treasure of home decor gift ideas to delight every South African African on your list."
                />}
            />
            <Route
              path='/test' exact render={(p) =>
                <>
                  <Helmet>
                    <meta name='robots' content='noindex, nofollow' />
                  </Helmet>
                  <DefaultSectionPage
                    {...props} {...p} isPage0={isPage0}
                    section='all-content-feed'
                    title='Test page | House &amp; Garden'
                    description='Test page for marketing purposes'
                  />
                </>}
            />
            <Route
              path='/:section([a-zA-Z0-9/-]+)' exact render={(p) =>
                <DefaultSectionPage
                  {...props} {...p} isPage0={isPage0}
                  title={getSectionLabel(url2section(props.location.pathname)) + ' | House & Garden'}
                  section={url2section(props.location.pathname)} url={props.location.pathname}
                />}
            />
            <Route path='*' render={(p) => <NotFound {...props} {...p} />} />
          </Switch>
        )}
        <Route
          path='/authors/:section([a-zA-Z-]+)' render={(p) => (<AuthorSectionPage {...props} {...p} template={AuthorArticles} title={getSectionLabel(url2section(props.location.pathname)) + ' | House & Garden'} section={url2section(props.location.pathname)} url={props.location.pathname} authorSlug={p.match.params.section} />)}
        />
        <Route path={props.match.url + '/:title*([-])*:contentKey([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})'} render={(p) => <Article {...props} {...p} contentKey={p.match.params.contentKey} />} />
        <Route path={props.match.url + '/:title*([-])*:contentKey([0-9]{5,})'} render={(p) => <Article {...props} {...p} contentKey={p.match.params.contentKey} />} />
        <Route path={props.match.url + '/:section([a-zA-Z0-9-]+)'} render={(p) => <DefaultSection {...props} {...p} />} />
      </Switch>
    </>
  )
}

export default DefaultSection
